import { testWebhook } from '@/services/api';
import { TriggerType } from '@d-id/types';
import { useMutation } from 'react-query';

export interface Auth {
    type: 'bearer' | 'api_key' | 'basic' | 'none';
    header_name?: string;
    secret_id?: string;
    username?: string;
}

export interface Credentials extends Auth {
    token?: string;
    api_key?: string;
    username?: string;
    password?: string;
}

export interface TestWebhookRequestDto {
    event_type: TriggerType.chatEnd;
    url: string;
    auth?: Credentials;
    headers?: Record<string, string>;
}

export interface TestWebhookResponseDto {
    success: boolean;
    status_code?: number;
    response_data?: unknown;
    error_message?: string;
    request_payload: unknown;
}

export const useWebhookTest = () => {
    return useMutation<TestWebhookResponseDto, Error, TestWebhookRequestDto>('webhook-test', testWebhook);
};
